import { render, staticRenderFns } from "./ExpiryTable.vue?vue&type=template&id=038e811b&scoped=true"
import script from "./ExpiryTable.vue?vue&type=script&lang=js"
export * from "./ExpiryTable.vue?vue&type=script&lang=js"
import style0 from "./ExpiryTable.vue?vue&type=style&index=0&id=038e811b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038e811b",
  null
  
)

export default component.exports